module.exports = __webpack_public_path__ + "img/08.641a4968.png";